import { Action } from '@ngrx/store';

export enum ShipmentActionsTypes {
  Load = '[ShipmentActionsTypes] Load shipments',
  LoadSuccess = '[ShipmentActionsTypes] Load shipments success',
  LoadFail = '[ShipmentActionsTypes] Load shipments fail',
}

export class Load implements Action {
  readonly type = ShipmentActionsTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = ShipmentActionsTypes.LoadSuccess;
  constructor(public shipments: any) {}
}

export class LoadFail implements Action {
  readonly type = ShipmentActionsTypes.LoadFail;
  constructor(public error: any) {}
}

export type ShipmentActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
;
